import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { ScrollView } from "react-native";
import InfoIcon from "@mui/icons-material/Info";
import { BACKGROUND_COLORS, TEXT_COLORS, BRAND_COLORS } from "../../style/colors.js";

export default function ImageDetailsComponent({ imageUrl, mo }) {
  const [modalVisible, setModalVisible] = useState(false);
  const lastPart = imageUrl ? imageUrl.split("/").pop() : "";

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleOpenModal = () => {
    if (imageUrl) {
      setModalVisible(true);
    }
  };

  return (
    <Box>
      {imageUrl && ( // Verificación de la URL antes de mostrar el botón
        <>
          {/* Botón externo con ícono */}
          <IconButton
            onClick={handleOpenModal}
            style={{
              color: BRAND_COLORS.PRIMARY,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}>
            <InfoIcon fontSize='large' />
            {/* <Typography variant='caption'>Detalles</Typography> */}
          </IconButton>

          {/* Modal de detalles */}
          <Dialog
            open={modalVisible}
            onClose={closeModal}
            maxWidth='md'
            fullWidth
            sx={{ "& .MuiDialog-paper": { backgroundColor: BACKGROUND_COLORS.TABLE_HEADER } }}>
            <DialogContent>
              <ScrollView>
                <Box display='flex' flexDirection='column' alignItems='center'>
                  {/* Primera fila con información */}
                  <Box
                    display='flex'
                    flexDirection='row'
                    flexWrap='wrap'
                    gap={2}
                    justifyContent='space-between'
                    width='100%'>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        Cantidad:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.cantidad}
                      </Typography>
                    </Box>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        Fecha Entrega:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.fechaentrega?.date
                          ? mo.fechaentrega.date.split(" ")[0]
                          : mo.fechaEntrega?.date
                          ? mo.fechaEntrega.date.split(" ")[0]
                          : "Fecha no disponible"}
                      </Typography>
                    </Box>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        {mo.gramos ? "Gramos" : "Peso bruto"}:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.gramos ? mo.gramos : mo.pesobruto}
                      </Typography>
                    </Box>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        MO:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.mo || mo.MO}
                      </Typography>
                    </Box>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        Referencia:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.referencia}
                      </Typography>
                    </Box>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        Stamping:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.stamping}
                      </Typography>
                    </Box>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        Observaciones:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.observaciones || "Sin observaciones"}
                      </Typography>
                    </Box>
                    <Box display='flex' flexDirection='column' minWidth={120}>
                      <Typography variant='body1' color={BRAND_COLORS.PRIMARY}>
                        Sureferencia:
                      </Typography>
                      <Typography variant='body1' color={TEXT_COLORS.DARK}>
                        {mo.sureferencia}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Imagen */}
                  <Box
                    component='img'
                    src={`https://catalog.facetbarcelona.com/images/database-odoo/FM/${lastPart}`}
                    alt='Imagen de Detalles'
                    sx={{
                      width: "90%",
                      height: "auto",
                      marginY: 2,
                      borderRadius: 2,
                      border: "1px solid black",
                      backgroundColor: "black",
                    }}
                  />
                </Box>
              </ScrollView>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeModal} color='primary' variant='contained'>
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Box>
  );
}
